import Form from './Form';

export default class GeneralInfoForm extends Form {
    templateId() {
        return '#generalInfoFormTemplate';
    }

    data() {
        return '/dashboard/profile/ajax/generalInfo/get';
    }

    onLoad(container) {
        var countryCode = $('#countryCode');
        countryCode.bfhcountries({
            country: countryCode.data('country'),
            available: countryCode.data('available')
        });

        var timezone = $('#timezone');
        timezone.bfhtimezones({
            country: timezone.data('country'),
            timezone: timezone.data('timezone')
        });
    }
}
